<template>
  <div class="page-header-phone">
    <a href="tel:1-888-746-3455" aria-label="Call us at 1.888.746.3455">+1.888.746.3455</a>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
